import { Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { isVerticalIpadMini } from '../common/responsiveUtils';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';

const Choices = (props) => {
  const { palette } = useTheme();
  const choice = props.choice;

  const answerColor = (isCorrect, isSelected) => {
    switch (isCorrect) {
      case true:
        return palette.green;
      case false:
        switch (isSelected) {
          case true:
            return palette.error.main;
          case false:
            return palette.primary.main;
        }
    }
  };

  const choiceBackgroundColor = (isCorrect, isSelected) => {
    switch (isCorrect) {
      case true:
        return palette.greenPale;
      case false:
        switch (isSelected) {
          case true:
            return palette.redPale;
          case false:
            return palette.text.disabled;
        }
    }
  };

  const choiceBorderColor = (isCorrect, isSelected) => {
    switch (isCorrect) {
      case true:
        return palette.green;
      case false:
        switch (isSelected) {
          case true:
            return palette.error.main;
          case false:
            return palette.outline.main;
        }
    }
  };

  return (
    <Paper elevation={0} variant="outlined"
      sx={{
        padding: '16px', marginTop: '16px',
        display: 'flex', alignItems: 'center',
        backgroundColor: choiceBackgroundColor(choice.isCorrect, choice.isSelected),
        borderColor: choiceBorderColor(choice.isCorrect, choice.isSelected),
      }}
    >
      <Radio checked={choice.isSelected}
        sx={{
          '&.Mui-checked': { color: answerColor(choice.isCorrect, choice.isSelected) },
          'width': '24px', 'height': '24px',
        }}
      />
      <Typography sx={{ marginLeft: '14px', justifyContent: 'center' }}>{choice.choiceText}</Typography>
    </Paper>
  );
};

const SelfCheckResultDialog = (props) => {
  const { typography } = useTheme();
  const isVerticalLong = isVerticalIpadMini();
  const selfCheckResult = props.selfCheckResult;

  const handleClose = () => {
    props.setOpen(false);
  };

  if (selfCheckResult) {
    return (
      <Dialog
        open={props.open}
        onClose={handleClose}
        fullWidth
        PaperProps={{
          sx: {
            minWidth: isVerticalLong ? '700px' : '800px',
            height: '600px',
          },
        }}
      >
        <DialogTitle variant='body16bold' textAlign='center' position='relative'>
          受講者セルフチェック
          <IconButton
            sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: isVerticalLong ? '24px 76px' : '24px 96px' }}>
          <Typography sx={{
            ...typography.body16bold,
            color: selfCheckResult.correctAnswerCount != selfCheckResult.itemCount ? 'error.main' : '',
          }}
          >
            正答数 {selfCheckResult.correctAnswerCount}/{selfCheckResult.itemCount}点
          </Typography>
          {selfCheckResult.detail.map((item, counter) => (
            <Stack key={counter} sx={{ marginTop: '40px' }}>
              <Stack direction='row'>
                <Typography sx={typography.body16bold}>問{counter + 1}：</Typography>
                <Typography sx={{ ...typography.body16bold, marginLeft: '8px', color: item.isCorrect?'green':'error.main' }}>
                  {item.isCorrect ? '⭘' : '×'}
                </Typography>
              </Stack>
              <Typography sx={{ marginBottom: '8px' }}>{item.questionText}</Typography>
              {item.choices.map((choice, index) => (
                <Choices choice={choice} key={index} />
              ))}
              <Choices choice={{
                choiceText: 'わからない',
                isCorrect: false,
                isSelected: item.choices.every((choice) => choice.isSelected === false),
              }} />
            </Stack>
          ))}
        </DialogContent>
      </Dialog>
    );
  }
};

export default SelfCheckResultDialog;

SelfCheckResultDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  selfCheckResult: PropTypes.object,
};

Choices.propTypes = {
  choice: PropTypes.object,
};
